import React from "react";
import Select from "./Select";
import CustomFilterInput from "./CustomFilterInput";
//props = {options, value, setValue, placeholder}
const FilterItem = ({ props }) => {
  return (
    <div className="p-2 md:m-2 mx-2 flex flex-col  items-start w-fit">
      <span className="text-dark-green font-bold text-nowrap font-poppins mr-4">
        {props.title}
      </span>
      {props.isInput ? (
        <CustomFilterInput {...props} />
      ) : (
        <div className="flex flex-row items-center gap-x-2">
          <Select {...props} canReset={true} />
        </div>
      )}
    </div>
  );
};

export default FilterItem;
